<template>
  <div class="row d-flex flex-row h-100">
    <auth-left-container> </auth-left-container>
    <div
      class="right-container bg-extra-light-gray p-4 d-flex flex-column justify-content-center align-items-center text-black"
    >
      <div class="center-form">
        <h2 class="mb-4" style="font-weight: bold;">
          Welcome!
        </h2>
        <form class="form-action" action="#" @submit.prevent="login">
          <b-form-group
            :state="formErrors.email.length == 0 ? null : false"
            :invalid-feedback="formErrors.email.join(', ')"
            style="margin-top: 35px;"
          >
            <b-form-input
              id="login-email"
              v-model="email"
              placeholder="Your email"
              class="auth-input bigger-input"
              :state="formErrors.email.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            :state="formErrors.password.length == 0 ? null : false"
            :invalid-feedback="formErrors.password.join(', ')"
            style="margin-top: 35px;"
          >
            <b-form-input
              id="login-password"
              v-model="password"
              type="password"
              placeholder="Password"
              class="auth-input bigger-input"
              :state="formErrors.password.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
          <div v-if="error">
            <label id="login-error" class="text-danger">{{ error }}</label>
          </div>

          <b-button
            id="login-button"
            type="submit"
            variant="primary"
            class="auth-button w-100"
            style="margin-top: 20px;"
            >Log In</b-button
          >
        </form>
        <div class="text-right" style="margin-top:45px;">
          <router-link to="/forgot-password">Forgot Password ?</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serverAuth from "../../server/auth";
import { setToken, getTFAToken, setTFAToken } from "../../helpers/session";
import { validateRequired } from "../../helpers/validation";
import AuthLeftContainer from "./AuthLeftContainer.vue";

export default {
  name: "AuthLogin",
  components: {
    AuthLeftContainer
  },
  data() {
    return {
      email: "",
      password: "",
      error: "",
      formErrors: {
        email: [],
        password: []
      }
    };
  },
  methods: {
    validateLogin() {
      let withoutErrors = true;

      this.formErrors.email = [];
      if (!validateRequired(this.email)) {
        this.formErrors.email.push("This field is required");
        withoutErrors = false;
      }
      this.formErrors.password = [];
      if (!validateRequired(this.password)) {
        this.formErrors.password.push("This field is required");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    async login() {
      const result = await this.validateLogin();
      if (result) {
        this.error = "";
        const twoFactorAuthToken = getTFAToken();
        const authResult = await serverAuth.authenticate({
          username: this.email,
          password: this.password,
          twoFactorAuthToken
        });
        if (authResult.errorCode) this.error = authResult.message;
        else if (authResult.twoFactorAuthKey) {
          this.$router.push(`/two-factor-auth/${authResult.twoFactorAuthKey}`);
        } else {
          setTFAToken(authResult.twoFactorAuthToken);
          await setToken(authResult.token);
          localStorage.setItem(
            "inactivityBegin",
            Math.floor(Date.now() / 1000)
          );

          const redirect = this.$route.query.redirect;
          const promise = this.$router.push("/");
          if (redirect) {
            promise.then(() => this.$router.push(redirect).catch(() => {}));
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.right-container {
  width: 50%;
}
.center-form {
  padding: 0px 15%;
}
.form-action {
  max-width: 400px;
  min-width: 400px;
}
</style>
